import React from "react";

export function DrawerContent(props) {
    return <div className={props.className + ' px-4'}>
        {props.children}
    </div>;
}